/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config";
import { Button } from "@material-tailwind/react";

const CallToAction = () => {
  return (
    <motion.div variants={animation}>
      <div className="relative">
        <video
          autoPlay
          muted
          loop
          className="w-full h-[45vh] object-cover object-top"
        >
          <source
            src={require("../../assets/images/cta-video.mp4")}
            type="video/mp4"
          />
        </video>

        {/* GRADIENT */}
        <div className="absolute top-0 left-0 w-full h-full">
          <div className="w-full h-full bg-gradient-to-r from-black to-transparent px-0 py-10 xl:p-20 lg:p-20">
            <div className="container">
              <h5 className="text-xl font-source font-semibold text-logo uppercase">
                Reconnect. Engage. Grow
              </h5>
              <div className="mt-5 w-full xl:w-1/2 lg:w-1/2">
                <h2 className="text-2xl xl:text-3xl lg:text-3xl font-roundo font-bold text-white">
                  Ready to Build a Thriving Alumni Network for Your Institution?
                </h2>
                <h5 className="mt-3 text-xl font-source font-normal text-white/80">
                  From onboarding to lifelong engagement, Alumni Connection Hub
                  gives your university everything it needs to foster meaningful
                  relationships with alumni.
                </h5>
                <a
                  href="https://calendly.com/roundtechsquare/new-meeting"
                  target="_blank"
                  className="block"
                  rel="noreferrer"
                >
                  <Button className="mt-5 shadow-none hover:shadow-none bg-logo hover:bg-opacity-70 transition-all duration-300 ease-in-out text-base font-medium font-source text-white normal-case">
                    Schedule a demo
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CallToAction;
